import { render } from "./HeaderGA.vue?vue&type=template&id=494a109a&scoped=true"
import script from "./HeaderGA.vue?vue&type=script&lang=js"
export * from "./HeaderGA.vue?vue&type=script&lang=js"

import "./HeaderGA.vue?vue&type=style&index=0&id=494a109a&scoped=true&lang=css"

import exportComponent from "/var/www/site/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-494a109a"]])

export default __exports__